import { motion } from 'framer-motion';
import { styled } from 'styled-components';

import { styledReset } from '@pkg/primitives';

export const Wrapper = styled(motion.div)``;

export const EditButton = styled(motion.button)`
    ${styledReset.button}

    border-radius: 40px;
    background: radial-gradient(67.31% 175% at 50% 148.75%, rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 0) 100%),
        rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(32px);

    height: 32px;
    padding: 0px 15px;

    flex-shrink: 0;

    color: #fff;
    text-align: center;

    font-size: 12px;
    font-weight: 700;
    line-height: 120%;
    letter-spacing: -0.24px;

    position: absolute;
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
    z-index: 10;

    transition: box-shadow 200ms ease;

    pointer-events: none;

    &:hover {
        box-shadow:
            0 0 68px 0 rgba(255, 255, 255, 0.1) inset,
            0 0 0 1px rgba(255, 255, 255, 0.1) inset;
    }
`;
